@import '@nora-monorepo/ui-shared/lib.css';

@source '../../../../../libs/nora-chat-ui/';
@source '../../../../../libs/ui-shared/';
@source '../../../../../libs/grammar-ui/';
